import Image from "next/image";
import {useTranslation} from "@i18n/client";
import React from "react";

import Button, {ButtonSize, ButtonVariant} from "../Button";
import {IllustratedTextDecoration} from "../IllustratedTextDecoration";
import {Trans} from "@i18n";

type Props = {
  jobCount: number;
  h1?: string;
  subheader?: JSX.Element | string;
  alt: string;
  caption?: JSX.Element;
  objectPosition?: string;
  hideGradient?: boolean;
  src: string;
};

const Hero: React.FC<Props> = ({
  jobCount,
  h1,
  subheader,
  src,
  alt,
  caption,
  objectPosition,
  hideGradient = false,
}) => {
  const i18n = useTranslation();

  return (
    <div className="relative">
      <Image src={src} fill priority alt={alt} className="object-cover" style={{objectPosition}} />
      <div
        className="h100p w100p pt100 pt70-xs ph8 ph5-xs pb40 pb14-xs pos-r"
        style={{
          background: hideGradient
            ? ""
            : "linear-gradient(230deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%",
        }}
      >
        <div className="maxw80 ma df fdc white">
          {Boolean(jobCount) && (
            <div className="df aic mb6 mb3-xs">
              <span className="mr3 font-ir fs14">
                <Trans t={i18n.t} count={jobCount}>
                  We're hiring for{" "}
                  <b>
                    <>{{count: jobCount}} roles</>
                  </b>
                </Trans>
              </span>
              <Button
                variant={ButtonVariant.WHITE}
                size={ButtonSize.SM}
                href="#careers"
                aria-label={i18n.t("Click to view available job openings.")}
              >
                {i18n.t("View Openings")}
              </Button>
            </div>
          )}

          <div className="mb6">
            <h1 className="fs60 fs40-md fs36-sm fs32-xs maxw60 maxw40-md maxw36-sm maxw22-xs">
              {h1 || (
                <Trans t={i18n.t}>
                  Making high-quality healthcare more accessible to{" "}
                  <span className="pos-r">
                    everyone.
                    <IllustratedTextDecoration type="underline" />
                  </span>
                </Trans>
              )}
            </h1>
            {subheader && <p className="fs18 font-cm ls-3 maxw26">{subheader}</p>}
          </div>
          <a
            href="#our-story"
            id="our-story"
            className="event-rM9BvY focus-bsDarkBlue3 wfc"
            aria-label={i18n.t("Click to navigate to the next section.")}
          >
            <span className="cIcon-arrow-down white fs40 fs30-sm fs24-xs" />
          </a>
        </div>
        {caption && (
          <div className="pos-a dn-md" style={{right: 30, bottom: 30}}>
            {caption}
          </div>
        )}
      </div>
    </div>
  );
};

export default Hero;
